// Generated by CoffeeScript 1.11.1
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/image',['require','./multiple_choice','../question_form','../../check_radio','sp/utilities/resize_image'],function(require) {
  var CheckRadio, Image, MultipleChoice, QuestionForm, resizeImage;
  MultipleChoice = require("./multiple_choice");
  QuestionForm = require('../question_form');
  CheckRadio = require("../../check_radio");
  resizeImage = require('sp/utilities/resize_image');
  return Image = (function(superClass) {
    extend(Image, superClass);

    function Image() {
      return Image.__super__.constructor.apply(this, arguments);
    }

    Image.SIZE_LARGE = [450, 325];

    Image.SIZE_MEDIUM = [200, 150];

    Image.SIZE_SMALL = [100, 75];

    Image.prototype.initialize = function(options) {
      return Image.__super__.initialize.call(this, options);
    };

    Image.prototype.render = function() {
      var fnc;
      this.$el.empty();
      _.each(this.model.get('properties').labels, (function(_this) {
        return function(label, index) {
          return _this.$el.append(_this.getChoice(label, index));
        };
      })(this));
      if (this.model.get('properties').random) {
        this.randomize();
      }
      if (this.model.get('properties').size) {
        fnc = function(index, css) {
          if (css) {
            return (css.match(/(^|\s)image-size-\S+/g) || []).join(' ');
          }
        };
        this.$el.removeClass(fnc).addClass("image-size-" + (this.model.get('properties').size));
      }
      if (this.$el.hasClass('hide-captions')) {
        this.$el.removeClass("hide-captions");
      }
      if (this.model.get('properties').hideCaptions) {
        this.$el.addClass("hide-captions");
      }
      return this.el;
    };

    Image.prototype.getChoice = function(choice, index) {
      var $caption, $figure, $img, $input, $li, id, img, imgSize, type;
      imgSize = (function() {
        switch (this.model.get('properties').size) {
          case 'large':
            return {
              w: Image.SIZE_LARGE[0],
              h: Image.SIZE_LARGE[1]
            };
          case 'small':
            return {
              w: Image.SIZE_SMALL[0],
              h: Image.SIZE_SMALL[1]
            };
          default:
            return {
              w: Image.SIZE_MEDIUM[0],
              h: Image.SIZE_MEDIUM[1]
            };
        }
      }).call(this);
      img = resizeImage(choice.image, imgSize.w, imgSize.h, 'pad');
      $img = $('<img>').attr({
        'src': img
      });
      $caption = $('<figcaption>').text(choice.label);
      $figure = $('<figure>').append([$img, $caption]);
      id = (this.model.get("_id")) + "[" + index + "]";
      $li = $("<li>").addClass('clearfix');
      type = this.model.get('properties').multi ? 'checkbox' : 'radio';
      $input = new CheckRadio(type, $figure, {
        name: this.model.get("_id") || "temporary",
        id: id,
        value: choice.image
      }).render(false).css({
        width: imgSize.w + 20
      });
      $input.change((function(_this) {
        return function(e) {
          _this.$el.find('label').removeClass('checked');
          _this.values = [];
          _this.$el.find('input:checked').each(function(index, item) {
            var $item, selected;
            $item = $(item);
            $item.closest('label').addClass('checked');
            selected = _.find(_this.model.get('properties').labels, {
              image: $item.attr('value')
            });
            if (selected) {
              return _this.values.push({
                label: selected.label,
                value: selected.image
              });
            }
          });
          return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
        };
      })(this));
      return $li.prepend($input);
    };

    return Image;

  })(MultipleChoice);
});

